import { useState } from 'react';

export const usePdfModal = () => {
    const [isDocumentAccepted, setIsDocumentAccepted] = useState(false);
    const [isDocumentRead, setIsDocumentRead] = useState(false);

    const handleDocumentAccepted = () => {
        setIsDocumentAccepted(true);
    };

    const handleDocumentRead = () => {
        setIsDocumentRead(true);
    };

    return {
        isDocumentAccepted,
        isDocumentRead,
        handleDocumentAccepted,
        handleDocumentRead,
    };
};
